import { ProductNodeBuilderProps } from 'components/common-form/builder/form/node/ProductNodeBuilder.model';
import { BatchNavigationContext } from 'components/common-form/contexts/batch/BatchNavigationContext';
import { useField } from 'components/common-form/hooks/useField';
import { useFieldTranslationKey } from 'components/common-form/hooks/useFieldTranslationKey';
import { usePatchedFieldHighlight } from 'components/common-form/hooks/usePatchedFieldHighlight';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { SalesCounterpartTypeahead } from 'components/shared/SalesCounterpartTypeahead/SalesCounterpartTypeAhead.withFilterApi';
import type { IntlKey } from 'locales';
import { FC, useContext } from 'react';

export const ClientListField: FC<ProductNodeBuilderProps> = ({ node: { id }, tabIndex }) => {
  const {
    metadata: { isReadOnly },
    data,
    setData,
  } = useField<'ClientListField'>(id);
  const translationKey = useFieldTranslationKey(id);
  const patchedFieldClassName = usePatchedFieldHighlight(id);
  const { isCellInactive, isFocused, lostInputBeforeEditing, onEditingKeyDown, onEditionCompleted } =
    useContext(BatchNavigationContext);

  return (
    <BlockOrientationFormGroup
      inputId={id}
      label={`form.${translationKey}` as IntlKey}
      className={patchedFieldClassName}
    >
      <SalesCounterpartTypeahead
        e2e={id}
        selectedItem={data}
        onSelectedItemChanged={setData}
        tabIndex={tabIndex}
        isCellInactive={isCellInactive}
        isFocused={isFocused}
        onEditingKeyDown={onEditingKeyDown}
        lostInputBeforeEditing={lostInputBeforeEditing}
        onEditionCompleted={onEditionCompleted}
        locked={isReadOnly}
      />
    </BlockOrientationFormGroup>
  );
};

ClientListField.displayName = 'ClientListField';
